import styled from 'styled-components';

export default styled.div`
  margin-top: 0.5rem;
  font-size: 0.8rem;
  font-weight: normal;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 0.5rem;
`;
